import React from "react";
import type { TypeFormFieldProps } from "./FormFieldTypes";
import FormFieldHybrid from "./FormFieldHybrid";

/**
 * FormField component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const FormField = React.forwardRef<HTMLDivElement, TypeFormFieldProps>(
  (props, ref) => <FormFieldHybrid {...props} ref={ref} />
);

FormField.displayName = "FormField";
export default FormField;
